<template>
<div class="page-in" style="">

  <!-- BARRA DI NAVIGAZIONE MY LOGIN -->
  <headbar></headbar>


   <div class="row pad-in " style="padding:20px 0;background:#E3EDF9;" >

      <div class="col s12 yo-text-xl yo-text-bold yo-spacing-s black" style="padding:0 50px;">CREDITI ECM ACQUISITI</div>
      <div class="col s12 yo-text-n  yo-spacing-s black" style="padding:0 50px 50px 50px;">
         Per ogni evento da lei frequentato le indichiamo i crediti ECM acquisiti.
         <br /><br />
Le ricordiamo che per aver diritto ai crediti ECM è necessario frequentare il 90% delle ore formative e superare (dove previsto) il test di apprendimento con il 75% di risposte esatte.
         <br /><br />
<strong>I crediti acquisiti con i corsi organizzati da Biomedia per il triennio 2020­-2022 sono {{crediti}}</strong>
         <br /><br />
Di seguito vedi tutti i corsi del triennio 2020-2022 che le hanno permesso di raggiungere questo risultato.
      </div>

      <div class="col s12 mylogin-elenco-res">
         <evento v-for="item in $contatto._ecm" :evento="item" :key="item.id" class="medicina"></evento>
      </div>
   </div>


   <!-- SEZIONE INTERESSE O RANDOM -->
   <eventiInteresse></eventiInteresse>

   <!-- SEZIONE AREE -->
   <aree></aree>

</div>
</template>

<script>
import headbar from '../components/Mylogin-headbar'
import evento from '../components/Mylogin-elenco-ecm'
import eventiInteresse from '../components/Eventi-interesse'
import aree from '../components/Aree'

export default {
   name: 'mylogin-ecm',
   components: {
     headbar,
      eventiInteresse,
      aree,
      evento
   },
   created () {
      this.$teras.page.title = "Mylogin Eventi Residenziali"
      this.$teras.page.sezione = "myLogin"
   },
   computed: {
      crediti: function () {
         var totale = 0
         for (let item of this.$contatto._ecm){
            //if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1)
               totale += item.crediti
         }
         return totale
      }
   }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Mylogin-crediti.vue